import { DialogContentText, DialogProps } from '@mui/material';

import { AppDialog } from 'components/Dialogs';
import strings from 'constants/index';

interface PromptDialogProps extends DialogProps {
  confirmMessage: string;
  confirmCallback: (ok: boolean) => void;
  buttonText?: string;
  showCancel?: boolean;
}

const PromptDialog = ({
  open,
  confirmMessage,
  confirmCallback,
  buttonText,
  showCancel,
}: PromptDialogProps) => (
  <AppDialog
    open={open}
    title={strings.warning}
    fullWidth={false}
    onClose={() => confirmCallback(false)}
    confirmButton={{
      label: buttonText ? buttonText : strings.discard,
      props: { onClick: () => confirmCallback(true) },
    }}
    closeButton={
      showCancel
        ? {
            label: strings.cancel,
            props: { onClick: () => confirmCallback(false) },
          }
        : undefined
    }
  >
    <DialogContentText>{confirmMessage}</DialogContentText>
  </AppDialog>
);

export default PromptDialog;
